import React, { Fragment } from 'react';
import useDefaultsCache from '../hooks/useDefaultsCache';
import ReactOlMap from '../react-ol/components/Map';
export var Map = _ref => {
  var {
    children,
    allowMapMarker,
    mapMarkerType,
    onMarkerLocationChange,
    markerStyle,
    style,
    canSnap
  } = _ref;
  var {
    cachedDefaults
  } = useDefaultsCache();
  if (!cachedDefaults) return /*#__PURE__*/React.createElement(Fragment, null);
  return /*#__PURE__*/React.createElement(ReactOlMap, {
    style: style,
    canSnap: canSnap,
    allowMapMarker: allowMapMarker,
    mapMarkerType: mapMarkerType,
    onMarkerLocationChange: onMarkerLocationChange,
    markerStyle: markerStyle
  }, children);
};